import React, { useEffect, useState, } from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
//js
import Client from "./MainComponent/Client.js";
import Login from "./MainComponent/Login.js";
import Private from "./MainComponent/Private.js";



function App() {

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const url = new URL(window.location.href);
    const userCode = params.get("UserCode");

    if (userCode &&
      userCode != "null") 
    {
      localStorage.setItem("UserCode", userCode);

      console.log("UserCode 저장:", userCode);

      // UserCode 파라미터 제거
      url.searchParams.delete("UserCode");

      // 주소 변경 (새로고침 없음)
      const newUrl =
        url.pathname +
        (url.searchParams.toString()
          ? `?${url.searchParams.toString()}`
          : "") +
        url.hash;

      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  return (
    <div id="App_Range">
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/main" element={<Client />} />
          <Route path="/private" element={<Private />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
